<template>
  <div class="plugin-wrapper" v-if="Array.isArray(source) && source.length">
    <div class="plugin-multi_image_product_swiper">
      <swiper class="swiper-x-container" :ref="'oSwiper' + _uid" :options="swiperOpts">
        <swiper-slide class="swiper-x-item" v-for="(item, index) in source" :key="index">
          <div class="swiper-item-wrapper">
            <CircleItem :source="item" />
          </div>
        </swiper-slide>
      </swiper>
      <SwiperNavigator v-if="enableNavBtns" :xSwiper="oSwiper" :total="source.length" />
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import CircleItem from '@/components/CircleItem';
import SwiperNavigator from '@/components/SwiperNavigator';

export default {
  name: "MultiImageProductSwiper",
  components: { swiper, swiperSlide, CircleItem, SwiperNavigator },
  props: {
    source: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      oSwiper: {},
      swiperOpts: {
        loop: this.source.length > 7,
        loopedSlides: this.source.length > 7 ? this.source.length + 2 : 0,
        speed: 1000,
        slidesPerView: this.source.length >= 7 ? 7 : 6,
        centeredSlides: this.source.length > 7,
        centeredSlidesBounds: this.source.length > 7,
        centerInsufficientSlides: this.source.length < 7,
        breakpoints: {
          768: { // 小于等于768
            loop: this.source.length > 3,
            slidesPerView: 3,
            centeredSlides: this.source.length > 3,
            centeredSlidesBounds: this.source.length > 3,
            centerInsufficientSlides: this.source.length < 3,
            spaceBetween: 0
          },
          1024: {
            loop: this.source.length > 5,
            slidesPerView: 4.8,
            centeredSlides: this.source.length > 5,
            centeredSlidesBounds: this.source.length > 5,
            centerInsufficientSlides: this.source.length < 5,
            spaceBetween: 0
          },
          1200: {
            loop: this.source.length > 5,
            slidesPerView: 4.5,
            centeredSlides: this.source.length > 5,
            centeredSlidesBounds: this.source.length > 5,
            centerInsufficientSlides: this.source.length < 5,
            spaceBetween: 0
          }
        },
        navigation: {
          prevEl: `.swiper${this._uid} .carousel__btn--prev`,
          nextEl: `.swiper${this._uid} .carousel__btn--next`
        }
      },
      enableNavBtns: true
    };
  },
  created() {
    this.initNavBtnStatus();
  },
  mounted() {
    this.oSwiper = this.$refs?.[`oSwiper` + this._uid]?.swiper;
  },
  methods: {
    initNavBtnStatus() {
      let winW = window.innerWidth;
      if (winW >= 1200) {
        this.enableNavBtns = this.source.length > 7;
      } else if (winW >= 768) {
        this.enableNavBtns = this.source.length > 5;
      } else if (winW < 768) {
        this.enableNavBtns = this.source.length > 3;
      } else {
        this.enableNavBtns = false;
      }
    }
  },
  computed: {},
  watch: {}
}
</script>

<style lang="scss" scoped>
  .plugin-wrapper {
    display: flex;
    justify-content: center;
    .plugin-multi_image_product_swiper {
      position: relative;
      // padding-bottom: 1.5625rem;
      // margin: 0 -4.875rem;
      margin-top: 3.8125rem;
      width: 32.1875rem;
      max-width: 100%;
      // height: 14.9375rem;
      // .swiper-x-container { height: 14.9375rem; }
      .swiper-item-wrapper { padding: 0 .5rem; }
      & /deep/ .swiper-navigation-btns {
        padding: 0;
      }
    }
  }
  @media screen and (min-width: 48em) {
    .plugin-wrapper {
      .plugin-multi_image_product_swiper {
        // padding-bottom: 2.5rem;
        // margin: 0 -5.9375rem;
        margin-top: 4.625rem;
        width: 58.8125rem;
        // height: 16.8125rem;
        // .swiper-x-container { height: 16.8125rem; }
        .swiper-item-wrapper { padding: 0 .6875rem; }
      }
    }
  }
  @media screen and (min-width: 64em) {
    .plugin-wrapper {
      .plugin-multi_image_product_swiper {
        // padding-bottom: 3.125rem;
        margin: 0 -7.8125rem;
        width: 78.5625rem;
        // height: 21.1875rem;
        margin-top: 6.25rem;
        // .swiper-x-container { height: 21.1875rem; }
        .swiper-item-wrapper { padding: 0 .5rem; }
      }
    }
  }
  @media screen and (min-width: 75em) {
    .plugin-wrapper {
      .plugin-multi_image_product_swiper {
        margin: 0 -6.125rem;
        width: 86.1875rem;
        // height: 18.375rem;
        margin-top: 6.25rem;
        // .swiper-x-container { height: 18.375rem; }
        .swiper-item-wrapper { padding: 0 1rem; }
      }
    }
  }
</style>